import React from 'react';

import './ProblemFive.css';
import topicAreaIcon from "../../../../../resources/images/topic-area-icon.png";
import {StandardButton} from "../../../../common/button/standard-button/StandardButton";
import {NextButton} from "../../../../common/button/next-button/NextButton";
import {BackButton} from "../../../../common/button/back-button/BackButton";
import {BreadCrumbTrail} from "../../../../common/breadcrumb-trail/BreadcrumbTrail";
import {BaselineGraph} from "./baseline-graph/BaselineGraph";
import {baselineReportID, powerBIBase} from "../../../../../config/PowerBiReportConfig";

export const ProblemFive = ({context, navigateTo, navigateBack}) => {

    const handleViewReportClick = () => {
        window.open(powerBIBase + baselineReportID + "/ReportSection");
    }

    return (
        <div className="wizard-content-container">
            <div className="wizard-main-content-container">
                <div className="wizard-left-container">
                    <div className="wizard-icon-container">
                        <img src={topicAreaIcon} alt="Aurum Logo" className="wizard-icon"/>
                    </div>
                    <p className="wizard-icon-label">{context.topicAreaScreen.topicArea.topicArea}</p>
                </div>
                <div className="wizard-right-container">
                    <div className="problem-five-header-container">
                        <h2 className="problem-five-header">{context.problemScreen.toImprove}</h2>
                        <div className="problem-five-powerbi-button-container">
                            <div className="problem-report-button-container">
                                <div className={"problem-report-button"} onClick={handleViewReportClick}>
                                    Power BI
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="problem-five-graph-container">
                        <BaselineGraph context={context}/>
                    </div>
                    {context.viewMode && <div className="back-to-overview-button-container">
                        <StandardButton text="Problem Overview" onClick={() => navigateTo("problemTree")}/>
                    </div>}
                    <div className="navigation-button-container">
                        <NextButton onClick={() => navigateTo("rootCauseOverview")}/>
                        <BackButton onClick={navigateBack}/>
                    </div>
                </div>
            </div>

            <div className="wizard-breadcrumb-container">
                <BreadCrumbTrail context={context} navigateTo={navigateTo}/>
            </div>
        </div>
    );
}
